/**
 * Get API Base URL - intelligent defaults based on hostname
 */
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  const hostname = window.location.hostname;
  if (hostname.includes('sccnhub.com')) {
    return 'https://api.sccnhub.com';
  }
  return 'http://localhost:5000';
};

/**
 * Get image source URL - handles both base64 and file URLs
 * @param {string} imageData - Either base64 string, file path, or URL
 * @returns {string} - Proper image src value
 */
export const getImageSrc = (imageData) => {
  if (!imageData || imageData === '') return '';
  
  // Ensure it's a string
  imageData = String(imageData).trim();
  
  // If it's already a full URL (http:// or https://), use it as-is
  if (imageData.startsWith('http://') || imageData.startsWith('https://')) {
    return imageData;
  }
  
  // If it's a relative path (starts with /uploads/), prepend the API base URL
  if (imageData.startsWith('/uploads/')) {
    return `${getApiBaseUrl()}${imageData}`;
  }
  
  // If it starts with /, assume it's an uploads path
  if (imageData.startsWith('/')) {
    return `${getApiBaseUrl()}${imageData}`;
  }
  
  // If it's already a data URI, use it as-is
  if (imageData.startsWith('data:')) {
    return imageData;
  }
  
  // Otherwise, it's likely base64 data - detect type and wrap it
  // WebP signature: starts with "UklGR"
  // PNG signature: starts with "iVBORw"
  // JPEG signature: starts with "/9j/"
  // GIF signature: starts with "R0lGOD"
  if (imageData.length > 10) {
    let mimeType = 'image/jpeg'; // default
    if (imageData.startsWith('UklGR')) {
      mimeType = 'image/webp';
    } else if (imageData.startsWith('iVBORw')) {
      mimeType = 'image/png';
    } else if (imageData.startsWith('R0lGOD')) {
      mimeType = 'image/gif';
    } else if (imageData.startsWith('/9j/')) {
      mimeType = 'image/jpeg';
    }
    
    return `data:${mimeType};base64,${imageData}`;
  }
  
  // Fallback
  return imageData;
};
